export default "__VITE_ASSET__b2HlaT4N__"